var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.578 2.44373L13.578 1.38867C11.822 0.463224 10.944 0 10 0C9.056 0 8.178 0.462219 6.422 1.38867L6.101 1.55848L15.024 6.68207L19.04 4.66238C18.394 3.92685 17.352 3.37721 15.578 2.44172M19.748 5.99277L15.75 8.00241V11.0531C15.75 11.2529 15.671 11.4446 15.5303 11.5859C15.3897 11.7273 15.1989 11.8067 15 11.8067C14.8011 11.8067 14.6103 11.7273 14.4697 11.5859C14.329 11.4446 14.25 11.2529 14.25 11.0531V8.75603L10.75 10.5145V20C11.468 19.8201 12.285 19.3901 13.578 18.7078L15.578 17.6527C17.729 16.5183 18.805 15.9516 19.403 14.9317C20 13.9128 20 12.6437 20 10.1085V9.99096C20 8.08883 20 6.89912 19.748 5.99277ZM9.25 20V10.5145L0.252 5.99277C8.9407e-08 6.89912 0 8.08883 0 9.98895V10.1065C0 12.6437 -1.19209e-07 13.9128 0.597 14.9317C1.195 15.9516 2.271 16.5193 4.422 17.6537L6.422 18.7078C7.715 19.3901 8.532 19.8201 9.25 20ZM0.96 4.66338L10 9.20519L13.411 7.49196L4.525 2.38947L4.422 2.44373C2.649 3.37822 1.606 3.92785 0.96 4.66439",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.a6800841e98efa3c13998cd2049c5535.svg";
export { ForwardRef as ReactComponent };